import i18n from '../../i18n';

export const MESSAGES = {
  UPDATE_MESSENGER_PROFILE: {
    ERROR: {
      401: i18n.t('You are not authorized to update messenger profile.'),
      403: i18n.t('You are not allowed to update messenger profile.'),
      404: i18n.t('The messenger profile you are trying to update does not exist.'),
      500: i18n.t('An error occurred updating the messenger profile.'),
      default: i18n.t('An error occurred updating the messenger profile.')
    },
    SUCCESS: {
      200: i18n.t('Messenger profile updated successfully.')
    }
  },
  DELETE_MESSENGER_PROFILE: {
    ERROR: {
      401: i18n.t('You are not authorized to delete messenger profile.'),
      403: i18n.t('You are not allowed to delete messenger profile.'),
      404: i18n.t('The messenger profile you are trying to delete does not exist.'),
      500: i18n.t('An error occurred deleting the messenger profile.'),
      default: i18n.t('An error occurred deleting the messenger profile.')
    },
    SUCCESS: {
      200: i18n.t('Messenger profile deleted successfully.')
    }
  }
};
